<style lang="scss" scoped>
.items-container {
}

.loading-div {
  display: flex;
  align-items: center;
  justify-content: center;
}

.items-list {
  overflow-y: auto;
}

.damage-value {
  color: var(--v-red-base);
}

.success-value {
  color: var(--v-success-darken1);
}
</style>
<template>
  <div>
    <v-card elevation="5" color="primary lighten-1" style="border-radius: 0">
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6">
            <v-card elevation="2" color="#f1f1f1">
              <v-card-subtitle>Débito total</v-card-subtitle>
              <v-card-text>
                <v-row no-gutters>
                  <v-col
                    class="headline"
                    :class="
                      details.credito_utilizado >= details.credito_total
                        ? ''
                        : ''
                    "
                  >
                    {{ formatMoney(details.credito_utilizado) }}
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col
                    class="subtitle-1"
                    :class="
                      details.credito_disponivel < 0
                        ? 'damage-value'
                        : 'success-value'
                    "
                  >
                    <span>
                      {{ formatMoney(details.credito_disponivel) }}
                      liberado
                    </span>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  @click="handleClickAdjustValue()"
                  small
                  text
                  color="orange"
                >
                  <v-icon small class="mr-1">mdi-alert-decagram-outline</v-icon>
                  Ajustar
                </v-btn>
                <v-btn
                  @click="paying_dialog = true"
                  small
                  text
                  color="primary"
                  v-if="details.credito_utilizado > 0"
                >
                  Quitar
                </v-btn>
                <v-btn
                  @click="paying_dialog = true"
                  small
                  text
                  color="primary"
                  v-else
                >
                  Creditar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col class="text-right">
            <v-btn @click="confirmPrintHistory" class="mr-1" text dark>
              <v-icon left>mdi-printer</v-icon>
              Imprimir Histórico
            </v-btn>
            <v-btn @click="getCreditTransactions()" icon dark>
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          dark
          v-if="show_all == false"
          @click="show_all = true"
          text
          small
        >
          Mostrar Mais antigo
        </v-btn>
        <v-btn dark v-else @click="show_all = false" text small>
          Somente Mais recente
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-divider></v-divider>

    <div v-if="loading" class="items-container loading-div">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <v-list
      three-line
      class="items-container items-list"
      v-else-if="transactions.length > 0"
      ref="transactions_list"
    >
      <div
        v-for="(transaction, index) in transaction_list"
        :key="transaction.id"
      >
        <v-list-item :to="getLink(transaction)">
          <v-list-item-avatar>
            <Avatar
              v-if="transaction.user"
              :user_id="transaction.user.id"
              :user_name="transaction.user.name"
              :avatar_url="transaction.user.avatar_url"
              size="40"
            />
            <v-avatar v-else color="grey lighten-1">
              <v-icon size="20" color="white">mdi-cog</v-icon>
            </v-avatar>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              {{ transaction.motive }}
              <v-icon v-if="getLink(transaction)" small color="primary">
                mdi-open-in-new
              </v-icon>
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ getResponsibleText(transaction.user) }}
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              {{ formatDateTime(transaction.created_at) }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action
            :class="classByValue(transaction.amount)"
            class="font-weight-normal subtitle-1"
          >
            {{ formatMoney(transaction.amount) }}
          </v-list-item-action>
        </v-list-item>
        <v-divider inset v-if="index + 1 < transaction_list.length"></v-divider>
      </div>
    </v-list>
    <v-row v-else class="items-container loading-div">
      <v-col class="text-center grey--text">
        <span>Nenhuma movimentação encontrada</span>
        <br />
        <v-btn :to="{ name: 'new_pedido' }" color="primary" text>
          Fazer venda <v-icon right size="20"> mdi-open-in-new </v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-divider></v-divider>

    <v-dialog v-model="paying_dialog">
      <v-card :disabled="loading_payoff">
        <v-form @submit.prevent="handleConfirmPayoff()">
          <ValidationObserver ref="payoff_form">
            <v-card-title>
              Quitar
              <v-spacer></v-spacer>
              <v-btn @click="paying_dialog = false" icon>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <ValidationProvider
                    name="payoff_value"
                    :rules="{
                      required: true,
                      min_value: 0.01
                    }"
                    v-slot="{ errors }"
                  >
                    <MoneyInput
                      v-model="payoff_value"
                      :error-messages="errors"
                      label="Quantia recebida"
                      prefix="R$"
                      name="payoff_value"
                    >
                      <template slot="prepend-inner"> R$ </template>
                    </MoneyInput>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                @click="paying_dialog = false"
                color="grey lighten-2"
                elevation="0"
                :disabled="loading_payoff"
              >
                Cancelar
              </v-btn>
              <v-btn type="submit" color="primary" :loading="loading_payoff">
                Confirmar
              </v-btn>
            </v-card-actions>
          </ValidationObserver>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="adjustment_dialog" max-width="500">
      <v-card :disabled="loading_payoff">
        <ValidationObserver ref="adjustment_form" v-slot="{}">
          <v-form @submit.prevent="handleConfirmAdjustment()">
            <v-card-title>
              Ajustar conta
              <v-spacer></v-spacer>
              <v-btn @click="adjustment_dialog = false" icon>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-subtitle>
              Lança uma atualização na ficha do cliente com uma movimentação
              equivalente à diferença entre o valor ajustado e o valor atual.
              <br />
              <b>Registra o responsável pela ação.</b>
            </v-card-subtitle>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <ValidationProvider
                    name="adjustment_value"
                    :rules="{
                      required: true,
                      min: 0,
                      is_not: details.credito_utilizado
                    }"
                    mode="lazy"
                    v-slot="{ errors }"
                  >
                    <MoneyInput
                      v-model="adjustment_value"
                      label="Ajustar para"
                      prefix="R$"
                      :error-messages="errors"
                      name="adjustment_value"
                    >
                      <template slot="prepend-inner"> R$ </template>
                    </MoneyInput>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                @click="adjustment_dialog = false"
                color="grey lighten-2"
                elevation="0"
                :disabled="adjustment_loading"
              >
                Cancelar
              </v-btn>
              <v-btn
                type="submit"
                color="orange"
                dark
                :loading="adjustment_loading"
              >
                <v-icon left>mdi-alert-decagram-outline</v-icon> Confirmar
              </v-btn>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-dialog>

    <confirm-print
      v-model="print_dialog"
      @action="printHistory"
      :default_copies="1"
      message="Tem certeza que deseja imprimir o histórico de movimentação deste cliente?"
    />
  </div>
</template>

<script>
import { index } from "@/services/credit_transactions";
import { quitarConta, alterarConta } from "@/services/clients";
import { printClientHistory } from "@/services/print";

import MoneyMixin from "@/mixins/MoneyMixin";
import DateTimeMixin from "@/mixins/DateTimeMixin";

import Avatar from "@/components/Avatar";
import MoneyInput from "@/components/MoneyInput";
import ConfirmPrint from "@/components/ConfirmPrint";

export default {
  name: "client-credit-transactions-tab",
  components: { Avatar, MoneyInput, ConfirmPrint },
  mixins: [MoneyMixin, DateTimeMixin],
  props: {
    client_id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    transactions: [],
    loading: false,
    error: null,
    paying_dialog: false,
    details: {},
    payoff_value: 0,
    loading_payoff: false,
    show_all: false,
    adjustment_dialog: false,
    adjustment_loading: false,
    adjustment_value: 0,
    print_dialog: false
  }),
  methods: {
    getLink(transaction) {
      if (!transaction.type || !transaction.target) return;

      if (transaction.type === "venda") {
        return `/pedidos/${transaction.target}`;
      }

      if (transaction.type === "devolucao") {
        return `/devolucoes/${transaction.target}`;
      }

      return;
    },
    confirmPrintHistory() {
      this.print_dialog = true;
    },
    async printHistory(payload) {
      try {
        await printClientHistory(this.client_id, payload);
        this.$store.commit("sendMessage", {
          text:
            "Histórico de movimentação do cliente foi enviado para impressão",
          color: "success"
        });
      } catch (error) {
        this.$store.commit("sendMessage", {
          text:
            "Não foi possível enviar o histórico de movimentação do cliente para impressão",
          color: "error"
        });
      }
    },
    async getCreditTransactions() {
      this.loading = true;

      this.transactions = [];
      try {
        const response = await index(this.client_id);
        this.transactions = response.transactions;
        this.details = response.details;
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    classByValue(value) {
      return value >= 0 ? "" : "green--text";
    },
    getResponsibleText(user) {
      return user ? `Realizado por ${user.name}` : "Ação automática do sistema";
    },
    async handleConfirmPayoff() {
      const validation = await this.$refs["payoff_form"].validate();
      if (!validation) return;

      this.loading_payoff = true;
      try {
        const response = await quitarConta(this.client_id, this.payoff_value);
        this.transactions = response.transactions;
        this.details = response.details;

        this.paying_dialog = false;
        this.payoff_value = 0;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading_payoff = false;
      }
    },
    handleClickAdjustValue() {
      this.adjustment_dialog = true;
      this.adjustment_value = this.details.credito_utilizado;
    },
    async handleConfirmAdjustment() {
      const validation = await this.$refs["adjustment_form"].validate();
      if (!validation) return;

      this.adjustment_loading = true;
      try {
        const response = await alterarConta(
          this.client_id,
          this.adjustment_value
        );
        this.transactions = response.transactions;
        this.details = response.details;

        this.$refs["adjustment_form"].reset();
        this.adjustment_dialog = false;
      } catch (error) {
        console.error(error);
      } finally {
        this.adjustment_loading = false;
      }
    }
  },
  created() {
    this.getCreditTransactions();
  },
  watch: {
    client_id: function(value) {
      if (value) this.getCreditTransactions();
    }
  },
  computed: {
    transaction_list: function() {
      return this.show_all ? this.transactions : this.transactions.slice(-4);
    },
    user: function() {
      return this.$store.getters.getUser;
    }
  }
};
</script>
